import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AccountInfoData } from "../../../../../../../common/AccountInfoData";

export const k8sClusterColumnDef: ColDef = {
  field: "resource.cluster",
  headerName: "Cluster",
  valueGetter: ({ data }) =>
    data?.resource?.cluster?.name ?? data?.resource?.cluster?.provider_id ?? "",

  cellRenderer: ({ data }: ICellRendererParams) => {
    const cluster = data?.resource?.cluster;

    if (!cluster) {
      return null;
    }

    return (
      <AccountInfoData
        provider={cluster.provider}
        accountName={cluster.name ?? cluster.provider_id}
        nameTypographyProps={{ fontSize: 14 }}
      />
    );
  },
};
